var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#icon-btn_checkbox_selected';
                    var viewUrl = 'sprites.svg#view-icon-btn_checkbox_selected';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };